
let fromMini =  false;
let isFromNot =  false;


const getFromMini = function(){
    return fromMini;
}

const setFromMini = function(val){
    fromMini = val;
}

const setFromNot = (value)=>{
    isFromNot = value;
}

const getFromNot=()=>{
    return isFromNot;
}

const FlagEventMini = {
    getFromMini,
    setFromMini,
    setFromNot,
    getFromNot
};


export default FlagEventMini;


// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/FlagEventMini.js